import React from "react";
import styles from "./styles/Home.module.css";
import Carrusel from "./component/Carrusel";
import CarruselUser from "./component/CarruselUser";
import {Link} from 'react-router-dom';
import $ from "jquery";    
import { useState, useEffect } from "react";


const HomeClient = () => {

    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : {};
    });

    useEffect(() => {
        $("#welcome-title")
        .hide()
        .fadeIn(800);

        return () => {
        $("#welcome-title").stop(true, true).show();
        };
    }, []);



    return(
        <>

        <div name="Home" className={styles.home}> 
            <h2 id="welcome-title" style={{ width: '100%', textAlign: 'left', paddingLeft: 20 }}>Bienvenido, {usuario.Usuario}</h2>
            <div className={styles.titleConteiner}>    
            </div>
        </div>
            <Carrusel />
            <CarruselUser />

        </>
        
    );
};

export default HomeClient;